import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const signes = [
  "Volet immobile qui ne monte ni ne descend",
  "Moteur bruyant sans mouvement du tablier",
  "Blocage en pleine course d'ouverture ou fermeture",
  "Télécommande Nice sans effet sur le volet",
  "Moteur surchauffé ou odeur de brûlé",
  "Voyant de réception qui ne clignote plus",
];

export default function Panne() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Panne de moteur Nice : symptômes et causes
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Un moteur Nice de volet roulant peut tomber en panne pour plusieurs raisons : usure du moteur tubulaire, défaillance du condensateur, problème de récepteur radio ou dysfonctionnement de l'émetteur. Les motorisations Nice fonctionnent en filaire ou en radio (protocole OXIBD). Nos techniciens identifient rapidement la cause exacte grâce à un diagnostic complet sur place, en vérifiant chaque élément de la chaîne de commande.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Le remplacement d'un moteur Nice ne se limite pas au changement du tubulaire. Nous procédons au recâblage complet, à la reprogrammation de vos télécommandes et interrupteurs, ainsi qu'à la réinitialisation du récepteur radio si nécessaire. Que votre système soit en filaire ou en radio, nous assurons la compatibilité et le bon fonctionnement de l'ensemble des commandes.
            </p>
            <ul className="space-y-3 mb-8">
              {signes.map((signe) => (
                <li key={signe} className="flex items-center gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#00B3A4]/10 shrink-0">
                    <i className="ri-check-line text-[#00B3A4] text-sm"></i>
                  </span>
                  <span className="text-[#143A66] text-base font-medium">{signe}</span>
                </li>
              ))}
            </ul>
            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-lg font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>
          <div className="order-1 lg:order-2 relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/e2e658382b3406c337a88ce0460f4507.jpeg"
              alt="Signes de panne d'un moteur Nice de volet roulant à Strasbourg"
              className="w-full h-[340px] md:h-[420px]"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}